'use client';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    void fetch('/api/notify/teams', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        code: 'global_error',
        source: 'client',
        message: error.message,
        stack: error.stack,
        url: globalThis.window?.location.href,
        env: process.env.NODE_ENV,
        timestamp: new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Seoul' }))
          .toLocaleString('sv-SE')
          .replace('T', ' '),
      }),
    });
  }, [error]);

  // layout 바깥에서 렌더링되므로 <html><body> 직접 포함 필수
  return (
    <html lang="ko">
      <body>
        <h1>서비스 일시 중단</h1>
        <button type="button" onClick={reset}>
          다시 시도
        </button>
      </body>
    </html>
  );
}
